import { render, staticRenderFns } from "./SelectMeal.vue?vue&type=template&id=1d3a4270&lang=pug&"
import script from "./SelectMeal.vue?vue&type=script&lang=js&"
export * from "./SelectMeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports